
export function tryParseInt(intString) {
    if (!intString)
        return null;

    var result = parseInt(intString, 10);
    if (isNaN(result))
        return null;

    return result;
}
